<div class="ui-g-12 no-padding text-center">

	<ng-template
		#BackNavigation
		[ngIf]="isDisplayModeAvailable() === false
			|| displayMode !== displayModes.list">
		<div
			class="ui-g-12 no-padding text-left nested-display-header">
			<span
				class="text-link theme-color nested-display-back-container"
				(click)="displayMode = displayModes.list">
				<i class="fa fa-arrow-left nested-display-back-icon">
				</i>
				<span class="nested-display-back">
					Back
				</span>
			</span>
		</div>
	</ng-template>

	<ng-template
		#Invalid
		[ngIf]="isValid() === false
			|| isDisplayModeAvailable() === false
			|| isOwnershipAllowed === false"
		[ngIfElse]="Content">
		<div class="ui-g-12 text-center no-access-content">
			<div *ngIf="isOwnershipAllowed === true">
				This view is not currently available.
			</div>
			<div *ngIf="isOwnershipAllowed === false">
				<app-access-denied-content
					[drawerDisplay]="true"
					drawerName="Notes"
					[sessionIdentifier]="sessionIdentifier"
					[accessDeniedUrl]="accessDeniedUrl"
					[resources]="resources"
					[clientMessage]="clientMessage">
				</app-access-denied-content>
			</div>
		</div>
	</ng-template>

	<ng-template
		#Content>
		<ng-template
			#ListNote
			[ngIf]="displayMode === displayModes.list">
			<app-note-list
				[context]="context"
				[securityDefinitions]="securityDefinitions"
				(changeDisplayMode)="changeDisplayMode($event)"
				(changeSelectedItem)="changeSelectedItem($event)">
			</app-note-list>
		</ng-template>

		<ng-template
			#ViewNote
			[ngIf]="displayMode === displayModes.view">
			<app-note-view
				[context]="context"
				[securityDefinitions]="securityDefinitions"
				[selectedItem]="selectedItem"
				(changeDisplayMode)="changeDisplayMode($event)">
			</app-note-view>
		</ng-template>

		<ng-template
			#CreateNote
			[ngIf]="displayMode === displayModes.create">
			<app-note-create
				[context]="context"
				[securityDefinitions]="securityDefinitions"
				(changeDisplayMode)="changeDisplayMode($event)">
			</app-note-create>
		</ng-template>

		<ng-template
			#DeleteNote
			[ngIf]="displayMode === displayModes.delete">
			<app-note-delete
				[context]="context"
				[selectedItem]="selectedItem"
				[securityDefinitions]="securityDefinitions"
				(changeDisplayMode)="changeDisplayMode($event)">
			</app-note-delete>
		</ng-template>
	</ng-template>

</div>